import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CtaButtonProps = {
  label: string;
  id?: string;
  shake?: boolean;
  size?: 'lg' | 'md';
  className?: string;
};
export function CtaButton({
  label,
  id,
  shake = false,
  size = 'lg',
  className = ''
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'min-h-[68px] px-5 py-4 text-[17px] sm:text-xl' : 'min-h-[56px] px-4 py-3 text-[15px] sm:text-base';
  return <a id={id} href={CHECKOUT_URL} className={`group flex w-full items-center justify-center gap-3 rounded-2xl bg-cta text-center font-extrabold uppercase leading-tight tracking-tight text-white shadow-[0_12px_30px_-10px_rgba(31,168,85,0.75)] ring-1 ring-inset ring-white/20 transition-[background-color,transform] duration-150 ease-out hover:bg-cta-dark focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/40 active:scale-[0.98] ${sizing} ${shake ? 'animate-cta-shake' : ''} ${className}`} data-id="element-107" data-mp="llh23a4db6s5">
      <span data-id="element-108" data-mp="35y7jegm11101">{label}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-109" data-mp="35yz2iryft69f" />
    </a>;
}